import script from "./JaContentWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentWrapper.vue?vue&type=script&setup=true&lang=js"

import "./JaContentWrapper.vue?vue&type=style&index=0&id=25aa60cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25aa60cc"]])

export default __exports__